/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from "react"
import { Dimensions, FlatList, Image, Platform, ScrollView, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import LinearGradient from "react-native-linear-gradient"
import { useSharedValue } from "react-native-reanimated"
import Carousel from "react-native-reanimated-carousel"
import { useNavigation } from "@react-navigation/native"
import { CustomHeader, Screen, Text } from "components"
import { style } from "./styles"
import { translate } from "i18n"
import { useStores } from "models"
import { PaginationItem } from "../Home/helper/PaginationItem"
import useResponsiveWidth from "components/fitSize"
import { useSessionExpired } from "utils/function"
import goldCrown from "../../../../assets/images/crown-gold.png"
import silverCrown from "../../../../assets/images/crown-silver.png"
import bronzeCrown from "../../../../assets/images/crown-bronze.png"
import { upperCase } from "lodash"
import { useColor } from "app/theme/getThemes"
import { colors } from "colors"

export const MemberShipScreen = () => {
  const { userStore } = useStores()
  const { companyTheme } = useColor()
  const { sessionExpired } = useSessionExpired()
  const progressValue = useSharedValue(0)
  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const [currentTierIndex, setCurrentTierIndex] = useState(0)
  const [tiers, setTiers] = useState(null)

  const tierColor = {
    gold: ["#FFF5B7", "#FFD700", "#FFB14E", "#D99200"],
    silver: ["#E0E0E0", "#C0C0C0", "#A9A9A9", "#D4D4D4"],
    bronze: ["#E3B778", "#CD7F32", "#D8A162", "#A76B29"],
  }

  useEffect(() => {
    const getAllTier = async () => {
      try {
        const response = await fetch(`${process.env.API_URL}/api/tier/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userStore?.accessToken}`,
          },
        })

        if (response.ok) {
          const data = await response.json()
          // Map through tiers and add colors dynamically
          const tiersWithColors = data.map((tier) => ({
            ...tier,
            tierColors: tierColor[tier.tier_name.toLowerCase()] || [
              companyTheme.first,
              companyTheme.second,
            ],
          }))
          setTiers(tiersWithColors)
          console.log(tiersWithColors)
        } else {
          const errorData = await response.json()
          if (["Token expired", "Invalid token"].includes(errorData?.error)) {
            sessionExpired()
          }
        }
      } catch (error) {
        console.error("Failed to fetch tiers:", error)
      }
    }

    getAllTier()
  }, [])

  if (!tiers) {
    return <ActivityIndicator size="large" color="#000" />
  }

  // console.log("tiers", tiers)

  const currentTier = tiers[currentTierIndex]?.tier_name || "Default"
  const tierColors = tierColor[currentTier] || [companyTheme.first, companyTheme.second]

  const handleCarouselChange = (index) => {
    setCurrentTierIndex(index)
  }

  console.log(tiers[currentTierIndex]?.benefits)

  return (
    <>
      <CustomHeader headerTitle={translate("memberShipScreen.header")} />
      <Screen>
        <View style={{ height: "40%" }}>
          <View style={[{ minWidth: width, height: Platform.OS === "web" ? width * 0.4 : 250 }]}>
            <View
              style={[
                style.carouselContainer,
                {
                  width: width,
                  minHeight: Platform.OS === "web" ? width * 0.4 : 250,
                },
              ]}
            >
              <Carousel
                loop
                width={width}
                height={width / 1.8}
                data={tiers}
                onSnapToItem={handleCarouselChange}
                modeConfig={{
                  parallaxScrollingScale: Platform.OS === "web" ? 0.89 : 0.88,
                  parallaxScrollingOffset: 50,
                }}
                onProgressChange={(_, absoluteProgress) => (progressValue.value = absoluteProgress)}
                renderItem={({ item }) => (
                  <View style={{ padding: "5%" }}>
                    <View style={style.borderContainer}>
                      <LinearGradient
                        style={[
                          style.tierContentContainer,
                          {
                            padding: 0,
                            overflow: "hidden",
                            shadowColor: "#000",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.3,
                            shadowRadius: 6,
                          },
                        ]}
                        colors={item.tierColors} // Use tierColors from the item
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                      >
                        <View
                          style={{
                            display: "flex",
                            padding: "5%",
                            width: "100%",
                            marginBottom: "5%",
                            position: "relative",
                            zIndex: 999,
                          }}
                        >
                          <View>
                            <Text
                              style={[
                                style.tierSpendText,
                                { flex: 1, color: "black", fontSize: 10 },
                              ]}
                            >
                              Hit RM {item?.min_point_amt} to reach this Tier
                            </Text>
                          </View>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            padding: "5%",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                          }}
                        >
                          <Text style={[style.tierSpendText, { color: "black", fontSize: 25 }]}>
                            {item?.tier_name?.toLocaleUpperCase()}
                          </Text>
                          <Image
                            source={{ uri: item?.tier_image }}
                            resizeMode="contain"
                            style={[
                              style.voucherImage,
                              {
                                width: 70,
                                height: 70,
                                backgroundColor: item.tierColors[0], // Use the first color for the background
                              },
                            ]}
                          />
                        </View>
                      </LinearGradient>
                    </View>
                  </View>
                )}
              />
            </View>
            <View style={style.paginationDotContainer}>
              {tiers.map((_, index) => (
                <PaginationItem
                  animValue={progressValue}
                  index={index}
                  key={index}
                  length={tiers.length}
                />
              ))}
            </View>
          </View>
        </View>
        <View style={{ height: "60%" }}>
          {/* Your main container */}
          <View
            style={{
              flex: 1, // Must be flex: 1 to allow FlatList to grow
              padding: 20,
              backgroundColor: colors.background,
              borderTopLeftRadius: 50,
              borderTopRightRadius: 50,
            }}
          >
            <Text style={[style.tierTitle, { color: companyTheme.first }]}>{currentTier}</Text>

            {tiers[currentTierIndex]?.benefits?.length <= 0 ? (
              <View style={{ flex: 1, alignSelf: "center", marginTop: 20 }}>
                <Text style={{ color: colors.lightGrey }}>No Benefit Yet</Text>
              </View>
            ) : (
              <FlatList
                data={tiers[currentTierIndex]?.benefits}
                keyExtractor={(item, index) => `${index}`}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 0 }}
                renderItem={({ item }) => (
                  <View style={{ marginTop: 20, flexDirection: "row" }}>
                    <Image
                      source={{ uri: item?.benefit_image }}
                      style={[style.pointImage, { borderRadius: 5 }]}
                    />
                    <View style={style.benefitTextContainer}>
                      <Text style={style.benefitText}>{item?.benefit_title}</Text>
                      <Text style={style.benefitDesc}>{item?.benefit_description}</Text>
                    </View>
                  </View>
                )}
              />
            )}
          </View>
        </View>
      </Screen>
    </>
  )
}
